import { useState } from "react";
import { SidebarContext, SidebarState } from "./SidebarContext";

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [sidebarState, setSidebarState] = useState<SidebarState>(
    SidebarState.NAV,
  );

  const toggleSidebarState = (state: SidebarState) => {
    setSidebarState((prev) => (prev === state ? SidebarState.CLOSED : state));
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarState, setSidebarState, toggleSidebarState }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
